import { _axios } from '../../plugins/axios'
import store from '../../store'
import MetricsController from './MetricsController'

class NewCases extends MetricsController {
  canGroupByLocation = false

  getData () {
    const queryString = this.formatQueryParams()
    return _axios.get(`${store.getters['Organization/apiUrl']}/metrics/newCases${queryString}`)
      .then((response) => {
        this.value = response.data.payload.data.count

        return this.value
      })
  }
}

export default new NewCases()
